import React, { Component } from "react";
import { Button } from "react-bootstrap";
import i18n from "i18next";
import PropTypes from "prop-types";

export default class SoundRecorderProvider extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  render() {
    const { hide, setSoundRecorderVisible, formControlProps } = this.props;
    const label = formControlProps ? formControlProps.label : i18n.t("Sound.soundRecorder");

    return (
      <div style={{ display: hide ? "none" : "block" }}>
        <Button
          className="toolbarButton"
          onClick={() => {
            this.setState({ open: !this.state.open });
            setSoundRecorderVisible();
          }}
        >
          <i className="toolbarIcons material-icons">graphic_eq</i>
          {label}
        </Button>
      </div>
    );
  }
}

SoundRecorderProvider.propTypes = {
  formControlProps: PropTypes.object,
  value: PropTypes.any,
  id: PropTypes.any,
  hide: PropTypes.bool,
  setSoundRecorderVisible: PropTypes.func,
};
